import {
  ALIGN_CENTER,
  BG_CELL_TITLE,
  BORDER_CELL,
  SIZE_14,
} from '../data/excelJsData';

class HeadersExcelJsDecorator {
  constructor(worksheet) {
    this.ws = worksheet;
  }

  /**
   * Encabezado simple con rango dinámico basado en número de columnas
   * @param {object} header.title - Título del reporte
   * @param {string} header.rangoHeader - Rango de celdas a unir (por defecto A1:P1)
   * @returns {object} Devuelve el this para poder enlazar la función con otras
   */
  encabezadoSimpleRangoDimanico(header) {
    const { title, rangoHeader = 'A1:P1' } = header;

    // Título principal (rango dinámico basado en número de columnas)
    this.ws.getCell('A1').value = title;
    this.ws.mergeCells(rangoHeader);
    this.ws.getCell('A1').font = { ...this.SIZE_14, bold: true };
    this.ws.getCell('A1').alignment = this.ALIGN_CENTER;
    this.ws.getCell('A1').border = this.BORDER_CELL;

    return this;
  }

  encabezadoArchivoInstruccionesEmpleados(header) {
    const {
      title,
      subtitle,
      sectionTitle,
      sectionSubtitle,
      filaInicio = 1,
      rangoHeader = 'A1:H1',
      rangoSubtitle = 'A2:H2',
      rangoSection = 'A3:H3',
      rangoSectionSubtitle = 'A4:H4',
    } = header;

    const f1 = `A${filaInicio}`;
    const f2 = `A${filaInicio + 1}`;
    const f3 = `A${filaInicio + 2}`;
    const f4 = `A${filaInicio + 3}`;

    // 1. Título principal
    this.ws.getCell(f1).value = title;
    this.ws.mergeCells(rangoHeader);
    this.ws.getCell(f1).font = { ...this.SIZE_14, bold: true };
    this.ws.getCell(f1).alignment = this.ALIGN_CENTER;
    this.ws.getCell(f1).border = this.BORDER_CELL;
    this.ws.getCell(f1).fill = this.BG_CELL_TITLE;

    // 2. Subtítulo
    this.ws.getCell(f2).value = subtitle;
    this.ws.mergeCells(rangoSubtitle);
    this.ws.getCell(f2).font = { size: 11 };
    this.ws.getCell(f2).alignment = this.ALIGN_CENTER;
    this.ws.getCell(f2).border = this.BORDER_CELL;
    this.ws.getCell(f2).fill = this.BG_CELL_TITLE;
    this.ws.getRow(filaInicio + 1).height = 20;

    // 3. Título de sección
    if (sectionTitle) {
      this.ws.getCell(f3).value = sectionTitle;
      this.ws.mergeCells(rangoSection);
      this.ws.getCell(f3).font = { ...this.SIZE_14, bold: true };
      this.ws.getCell(f3).alignment = this.ALIGN_CENTER;
      this.ws.getCell(f3).border = this.BORDER_CELL;
      this.ws.getCell(f3).fill = this.BG_CELL_TITLE;
    }

    // 4. Subtítulo de sección
    if (sectionSubtitle) {
      this.ws.getCell(f4).value = sectionSubtitle;
      this.ws.mergeCells(rangoSectionSubtitle);
      this.ws.getCell(f4).font = { size: 11 };
      this.ws.getCell(f4).alignment = this.ALIGN_CENTER;
      this.ws.getCell(f4).border = this.BORDER_CELL;
      this.ws.getCell(f4).fill = this.BG_CELL_TITLE;
      this.ws.getRow(filaInicio + 3).height = 20;
    }

    return this;
  }
}

/**
 * Agrega propiedades de estilos a la clase, con el objetivo de reutilizar código.
 * Estas pripiedades se encuentran definidas en el diccionario de datos importado.
 *
 * No agregar estilos que no se usen dentro de la clase.
 */
HeadersExcelJsDecorator.prototype.ALIGN_CENTER = ALIGN_CENTER;
HeadersExcelJsDecorator.prototype.BORDER_CELL = BORDER_CELL;
HeadersExcelJsDecorator.prototype.BG_CELL_TITLE = BG_CELL_TITLE;
HeadersExcelJsDecorator.prototype.SIZE_14 = SIZE_14;

export default HeadersExcelJsDecorator;
